import Moment from 'moment';

class ContainerRoute {
    constructor(id, routeDate, routeNumber) {
        this.Id = id;
        this.RouteDate = Moment(routeDate).format('l');
        this.RouteNumber = routeNumber;
    }

}

export default ContainerRoute;